export default __webpack_public_path__ + "static/media/ic-check-green.6c2e171f.svg";